import { getApp } from 'firebase/app';

/**
 * Wrapper de Firebase Analytics (GA4). Carga perezosa del módulo de analytics
 * para no inflar el bundle si la medición está deshabilitada.
 * Falla en silencio ante adblockers o sin red.
 */
let analyticsInstance = null;
let readyPromise = null;
let enabled = false;

async function loadAndInit() {
  if (analyticsInstance) return analyticsInstance;
  if (!enabled) return null;
  try {
    const { getAnalytics, isSupported, setAnalyticsCollectionEnabled } = await import(
      'firebase/analytics'
    );
    const ok = await isSupported().catch(() => false);
    if (!ok) return null;
    analyticsInstance = getAnalytics(getApp());
    setAnalyticsCollectionEnabled(analyticsInstance, true);
    return analyticsInstance;
  } catch (e) {
    console.warn('[MLV] Firebase Analytics init falló:', e?.message || e);
    return null;
  }
}

export function initMlvAnalytics({ measurementId } = {}) {
  enabled = Boolean(measurementId);
  if (!enabled) return;
  readyPromise = loadAndInit();
}

/** No bloquea ni lanza. */
export function mlvAnalyticsLog(name, params = {}) {
  if (!enabled) return;
  void (readyPromise || loadAndInit()).then(async (inst) => {
    if (!inst) return;
    try {
      const { logEvent } = await import('firebase/analytics');
      logEvent(inst, name, params);
    } catch (_e) {
      /* ignore */
    }
  });
}

export function mlvAnalyticsSetUser(uid) {
  if (!enabled) return;
  void (readyPromise || loadAndInit()).then(async (inst) => {
    if (!inst) return;
    try {
      const { setUserId } = await import('firebase/analytics');
      setUserId(inst, uid || null);
    } catch (_e) {
      /* ignore */
    }
  });
}

export function mlvAnalyticsSetUserProps(props = {}) {
  if (!enabled) return;
  void (readyPromise || loadAndInit()).then(async (inst) => {
    if (!inst) return;
    try {
      const { setUserProperties } = await import('firebase/analytics');
      setUserProperties(inst, props);
    } catch (_e) {
      /* ignore */
    }
  });
}
